export const MapPinSVG = (props) => (
  <svg
    height={26}
    viewBox="0 0 18 26"
    width={18}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd" strokeWidth={1.2}>
      <path d="M13.3 9.422a4.097 4.097 0 11-8.194 0 4.097 4.097 0 018.194 0z" />
      <path d="M9.203 24.522c2.176-3.236 6.674-9.804 7.67-12.852a8.033 8.033 0 00.385-2.467 8.055 8.055 0 00-16.11 0c0 .86.138 1.71.385 2.467.996 3.048 5.494 9.616 7.67 12.852z" />
    </g>
  </svg>
);
